// components/SocialShare.jsx
import React from 'react';
import { 
    ShareAltOutlined, 
    FacebookFilled, 
    TwitterOutlined,
    WhatsAppOutlined,
    LinkedinFilled,
    CopyOutlined
} from '@ant-design/icons';
import { Tooltip, message } from 'antd';

const SocialShare = ({ 
    url = window.location.href, 
    title = "",
    description = "",
    image = ""
}) => {

    const shareOnFacebook = () => {
        // Facebook reads info from Open Graph Meta Tags only
        const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        
        // Make sure the page has correct Meta Tags before sharing
        console.log('Sharing URL:', url);
        console.log('Check Meta Tags at: https://developers.facebook.com/tools/debug/');
        
        window.open(shareUrl, 'facebook-share', 'width=600,height=400,scrollbars=yes,resizable=yes');
    };

    const shareOnTwitter = () => {
        const text = `${title} - ${description}`.substring(0, 250);
        const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
        window.open(shareUrl, 'twitter-share', 'width=580,height=296,scrollbars=yes');
    };

    const shareOnWhatsApp = () => {
        const text = `${title}\n\n${description}\n\n${url}`;
        const shareUrl = `https://wa.me/?text=${encodeURIComponent(text)}`;
        window.open(shareUrl, 'whatsapp-share');
    };

    const shareOnLinkedIn = () => {
        const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        window.open(shareUrl, 'linkedin-share', 'width=580,height=296,scrollbars=yes');
    };

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(url);
            message.success('Link copied successfully!');
        } catch (err) {
            console.error('Failed to copy:', err);
            message.error('Failed to copy the link');
        }
    };

    // Native Web Share API (for mobile)
    const handleNativeShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: title,
                    text: description,
                    url: url,
                });
            } catch (err) {
                if (err.name !== 'AbortError') {
                    console.error('Native share failed:', err);
                }
            }
        }
    };

    return (
        <div className="flex items-center gap-3">
            {/* Native Share Button (for mobile) */}
            {navigator.share && (
                <Tooltip title="Share">
                    <button
                        onClick={handleNativeShare}
                        className="p-3 bg-blue-100 hover:bg-blue-200 text-blue-600 rounded-full transition-colors duration-200 md:hidden"
                    >
                        <ShareAltOutlined className="text-lg" />
                    </button>
                </Tooltip>
            )}

            {/* Desktop Share Buttons */}
            <div className="hidden md:flex items-center gap-2">
                <Tooltip title="Share on Facebook">
                    <button
                        onClick={shareOnFacebook}
                        className="p-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors duration-200"
                    >
                        <FacebookFilled className="text-base" />
                    </button>
                </Tooltip>

                <Tooltip title="Share on Twitter">
                    <button
                        onClick={shareOnTwitter}
                        className="p-2 bg-sky-500 hover:bg-sky-600 text-white rounded-lg transition-colors duration-200"
                    >
                        <TwitterOutlined className="text-base" />
                    </button>
                </Tooltip>

                <Tooltip title="Share on WhatsApp">
                    <button
                        onClick={shareOnWhatsApp}
                        className="p-2 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors duration-200"
                    >
                        <WhatsAppOutlined className="text-base" />
                    </button>
                </Tooltip>

                <Tooltip title="Share on LinkedIn">
                    <button
                        onClick={shareOnLinkedIn}
                        className="p-2 bg-blue-700 hover:bg-blue-800 text-white rounded-lg transition-colors duration-200"
                    >
                        <LinkedinFilled className="text-base" />
                    </button>
                </Tooltip>

                <Tooltip title="Copy link">
                    <button
                        onClick={copyToClipboard}
                        className="p-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-colors duration-200"
                    >
                        <CopyOutlined className="text-base" />
                    </button>
                </Tooltip>
            </div>
        </div>
    );
};

export default SocialShare;